import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { ChunkErrorRecoveryService, isChunkLoadError } from './chunk-error-recovery.service';

/**
 * Bắt các lỗi không tải được lazy chunk xảy ra NGOÀI luồng điều hướng của Router
 * (ví dụ `import()` gọi trực tiếp trong component, hoặc promise bị reject mà
 * không ai catch). Trước đây những lỗi này chỉ hiện `Uncaught (in promise)`
 * trong console và người dùng bị kẹt màn hình mà không có cách nào thoát ra.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // Lấy service theo kiểu lazy: ErrorHandler được khởi tạo rất sớm, tránh kéo
  // Router vào injector trước khi nó sẵn sàng.
  private readonly injector = inject(Injector);

  handleError(error: unknown): void {
    // Promise bị reject sẽ được Angular bọc lại, lỗi thật nằm trong `rejection`.
    const unwrapped = (error as { rejection?: unknown })?.rejection ?? error;

    if (isChunkLoadError(unwrapped)) {
      // Không truyền đích: ErrorHandler không biết router đang đi đâu, mà
      // `window.location` lúc này vẫn là URL CŨ (navigation đã fail nên thanh
      // địa chỉ chưa đổi). Để service tự lấy URL router đang cố tới, nếu không
      // người dùng sẽ bị tải lại về đúng trang cũ — ví dụ quay lại `/login` và
      // phải đăng nhập thêm lần nữa.
      this.injector.get(ChunkErrorRecoveryService).recover();
      return;
    }

    console.error(error);
  }
}
